/* eslint-disable @typescript-eslint/quotes */
import React from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useTranslation } from "next-i18next";
import clsx from "clsx";
import { useMediaQuery } from "@material-ui/core";
import Typography from "./Typography";

const useStyles = makeStyles((theme) => ({
  root: {},
  box: {
    display: "flex",
    alignItems: "center",
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    borderRadius: "8px",
    minHeight: "32px",
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(0.5),
      marginRight: theme.spacing(1),
    },
  },
  remainigLive: {
    backgroundColor: theme.palette.positive.superlight,
    color: theme.palette.positive.main,
  },
  closed: {
    backgroundColor: theme.palette.negative.light,
    color: theme.palette.negative.dark,
  },
  dateText: {
    marginRight: theme.spacing(0.5),
  },
}));
interface Props {
  status: string;
  days_remaining: number | null;
  days_since_startdate: number | null;
  end_date: string | null;
}

const DaysRemaining = ({
  status,
  days_remaining,
  days_since_startdate,
  end_date,
}: Props) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation("markets");
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down("md"));

  switch (status) {
    case "LIVE": {
      return (
        <div className={clsx(classes.box, classes.remainigLive)}>
          <Typography
            variant={md ? "small2medium" : "secondary2medium"}
            style={{ color: theme.palette.positive.main }}
          >
            {days_remaining && days_remaining > 0
              ? t("markets.detailView.days.daysLeft", {
                count: days_remaining,
              })
              : t("markets.detailView.days.daysSince", {
                count: days_since_startdate,
              })}
          </Typography>
        </div>
      );
    }
    case "EXPIRED": {
      return (
        <div className={clsx(classes.box, classes.closed)}>
          <Typography
            variant="secondary2medium"
            color="inherit"
            className={classes.dateText}
          >
            Closed
          </Typography>
          <span>
            {end_date && new Date(end_date as string).toLocaleDateString(i18n.language, {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        </div>
      );
    }
    default:
      return null;
  }
};

export default DaysRemaining;
